export const accessTokenItemName = 'session.accessToken';
export const refreshTokenItemName = 'session.refreshToken';
// export const accessTokenItem = {
//   access_token: 'session.accessToken',
//   expires_at: 'session.accessTokenExpiresAt',
//   refresh_token: 'session.accessTokenRefreshToken',
// };
